import { enUS, ja } from "date-fns/locale";

export const getWeekDays = (locale: string) => {
  if (locale === "ja") return ["日", "月", "火", "水", "木", "金", "土"];
  return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
};

export const getDateLocale = (locale: string) => {
  return locale === "ja" ? ja : enUS;
};
